<template>
    <CicPopup
        :title="item.pointId ? 'Edit Delivery Point' : 'New Delivery Point'"
        saveable
        @blur="$emit('blur')"
        @input="$emit('input')"
    >
        <div class="item-form">
            <ul>
                <li class="form-label-first">
                    {{ $t('Name') }}
                </li>
                <li>
                    <CicTextbox
                        id="point_name"
                        :value="item.name"
                        :maxlength="64"
                        @input="(val) => updateFieldValue('name', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Outbound Number') }}
                </li>
                <li>
                    <CicTextbox
                        id="point_number"
                        :value="item.number"
                        :maxlength="32"
                        @input="(val) => updateFieldValue('number', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Max Number of Calls') }}
                </li>
                <li>
                    <CicNumber
                        id="point_maxCalls"
                        :min="0"
                        :value="item.maxCalls"
                        @input="(val) => updateFieldValue('maxCalls', val)"
                    />
                </li>
                <li class="form-label">
                    {{ $t('Disabled') }}
                </li>
                <li>
                    <CicCheckbox
                        id="point_disabled"
                        :value="item.disabled"
                        @input="(val) => updateFieldValue('disabled', val)"
                    />
                </li>
            </ul>
        </div>
    </CicPopup>
</template>

<script>
    import CicPopup from '@/components/CicPopup';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import CicNumber from '@/components/inputs/CicNumber';
    import CicTextbox from '@/components/inputs/CicTextbox';

    export default {
        name: 'EditDeliveryPoint',
        components: {
            CicNumber,
            CicCheckbox,
            CicPopup,
            CicTextbox,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
        },
        emits: ['blur', 'change', 'input'],
        methods: {
            updateFieldValue(field, val) {
                this.$emit('change', field, val);
            },
        },
    };
</script>
